import {z} from 'zod';
import {
  CreateJobRequest,
  JobField,
  UpdatePartKitRequest,
  UpdatePartsListRequest,
  UpdateRepairServicePerformedRequest,
} from '../api/generated/index.defs.ts';
import {mapNullToUndefined, nonEmptyString} from '../utils/zod.ts';
import {JobTypesSchema} from '../api/generated/enums.ts';

const baseJobSchema = z.object({
  serialNumber: nonEmptyString(),
  levelOfServiceId: mapNullToUndefined(z.number().optional()),
  assetNumber: mapNullToUndefined(z.string().optional()),
  clientName: nonEmptyString(),
  reference1: mapNullToUndefined(z.string().optional()),
  reference2: mapNullToUndefined(z.string().optional()),
  memo: mapNullToUndefined(z.string().optional()),
  notes: mapNullToUndefined(z.string().optional()),
  closedDate: mapNullToUndefined(z.string().optional()),
  partnerSiteId: z.number(),
  jobType: JobTypesSchema,
  partNumber: mapNullToUndefined(z.string().optional()),
  certScrapReportIssuedDate: mapNullToUndefined(z.date().optional()),
  oemCodeId: mapNullToUndefined(z.number().optional()),
  partTypeCodeId: mapNullToUndefined(z.number().optional()),
  upperConnectionCodeId: mapNullToUndefined(z.number().optional()),
  middleConnectionCodeId: mapNullToUndefined(z.number().optional()),
  lowerConnectionCodeId: mapNullToUndefined(z.number().optional()),
  workingPressureCodeId: mapNullToUndefined(z.number().optional()),
  serviceCodeId: mapNullToUndefined(z.number().optional()),
  currentShShLength: mapNullToUndefined(z.number().optional()),
  partDescription: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<CreateJobRequest>;
export type BaseJobSchema = z.TypeOf<typeof baseJobSchema>;

export const mmJobSchema = baseJobSchema.extend({
  levelOfServiceId: z.number(),
}) satisfies z.Schema<CreateJobRequest>;
export type MmJobSchema = z.TypeOf<typeof mmJobSchema>;

export const nonMmJobSchema = baseJobSchema.extend({
  oemCodeId: z.number(),
  partTypeCodeId: z.number(),
}) satisfies z.Schema<CreateJobRequest>;
export type NonMmJobSchema = z.TypeOf<typeof nonMmJobSchema>;

export const jobFieldsSchema = z.object({
  jobFields: z.array(
    z.object({
      id: z.number(),
      name: z.string(),
      type: z.string(),
      value: mapNullToUndefined(z.any().optional()),
      inactive: mapNullToUndefined(z.boolean().optional()),
      sortOrder: mapNullToUndefined(z.number().optional()),
    }) satisfies z.Schema<JobField>,
  ),
}) satisfies z.Schema<UpdateRepairServicePerformedRequest>;
export type JobFieldsSchema = z.TypeOf<typeof jobFieldsSchema>;

export const jobPartKitSchema = z.object({
  partKitNumber: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<UpdatePartKitRequest>;
export type JobPartKitSchema = z.TypeOf<typeof jobPartKitSchema>;

export const jobReplacedPartsSchema = z.object({
  partItems: z.array(
    z.object({
      id: mapNullToUndefined(z.number().optional()),
      partNumber: mapNullToUndefined(z.string().optional()),
      lotNumbers: z.array(
        z.object({
          id: mapNullToUndefined(z.number().optional()),
          value: mapNullToUndefined(z.string().optional()),
        }),
      ),
    }),
  ),
}) satisfies z.Schema<UpdatePartsListRequest>;
export type JobReplacedPartsSchema = z.TypeOf<typeof jobReplacedPartsSchema>;